import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime, map, startWith, takeUntil, tap } from 'rxjs/operators';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { assign } from 'lodash';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { ReportsService } from 'app/modules/admin/transactions/inwards/reports.service';
import { BuiltUpAreaService } from '../builtup-area.service';
import { BuiltUpArea } from '../builtup-area.types';
import { CommonDropDown, SingleCommonDropDown } from 'app/core/common/types/dropdown.types';
import { LookupService } from 'app/core/common/services/lookup.service';

@Component({
    selector: 'builtup-area-details',
    templateUrl: './builtup-area-details.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuiltUpAreaDetailsComponent implements OnInit, OnDestroy {

    builtUpArea: BuiltUpArea;
    builtUpAreaForm: FormGroup;
    dialogTitle = `New BuiltUp Area`
    alert: any;
    reportType: string;
    total;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    options: CommonDropDown[];
    filteredOptions: Observable<CommonDropDown[]>;


    builtUpAreaFilterForm: FormGroup;
    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private _data: {
            builtUpArea: BuiltUpArea,
            reportType: string
        },
        private builtUpAreaService: BuiltUpAreaService,
        private _matDialogRef: MatDialogRef<BuiltUpAreaDetailsComponent>,
        private _formBuilder: FormBuilder,
        private _fuseConfirmationService: FuseConfirmationService,
        private _alertMessage: AlertMessageService,
        private _lookupService: LookupService
    ) {
        this.reportType = this._data.reportType;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Open the drawer
        this.builtUpAreaForm = this._formBuilder.group({
            id: [''],
            reportId: [this._data.builtUpArea.reportId],
            type: [this._data.builtUpArea.type, [Validators.required]],
            // type: ['', [Validators.required]],
            area: [this._data.builtUpArea.area],
            areaAsPer: [''],
            orderIndex: [this._data.builtUpArea.orderIndex],
        });

        this._lookupService.getOptionByTypeId(80, this.reportType).subscribe((res) => {
            this.options = res;
            this.filteredOptions = this.builtUpAreaForm.get("areaAsPer")
                .valueChanges.pipe(
                    startWith(''),
                    map(value => this._optionsfilter(value || '')),
                );
        })

        if (this._data.builtUpArea.id) {
            // Request the data from the server
            this.builtUpAreaService.getBuiltUpArea(this._data.builtUpArea.id)
                .subscribe((res) => {
                    if (res.isSuccess) {
                        this.builtUpArea = res.result;
                        this.dialogTitle = `Edit BuiltUp Area`;
                        this.builtUpAreaForm.patchValue(this.builtUpArea);
                    }
                    else {
                        this._alertMessage.error(res.errors.join('\n'));
                        this.onClose();
                    }
                });
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Close the drawer
     */
    // closeDrawer(): Promise<MatDrawerToggleResult> {
    //     return this._optionTypesListComponent.matDrawer.close();
    // }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
    setResetForm(oldData: BuiltUpArea) {
        this._data.builtUpArea as BuiltUpArea;
        this._data.builtUpArea.reportId = oldData.reportId;
        this._data.builtUpArea.orderIndex = oldData.orderIndex + 1;
        this.builtUpAreaForm.reset();
        this.builtUpAreaForm.patchValue(this._data.builtUpArea);
    }
    saveAndNew() {
        const builtUpArea = this.builtUpAreaForm.getRawValue();
        this.save(builtUpArea, true)
    }
    saveAndClose() {
        const builtUpArea = this.builtUpAreaForm.getRawValue();

        this.save(builtUpArea);
    }

    save(builtUpArea, isOpen = false) {
        this.builtUpAreaService.createBuiltUpArea(builtUpArea).subscribe((response) => {
            if (response.isSuccess) {
                // Show a success message
                this._alertMessage.success("BuiltUpArea added successfully");
                // Close the dialog
                if (!isOpen) {
                    this._matDialogRef.close(response);
                }
                else {
                    this.setResetForm(builtUpArea);
                }
            }
            else {
                this._alertMessage.error(response.errors.join("\n"));
            }
        });
    }
    updateAndClose() {

        const builtUpArea = this.builtUpAreaForm.getRawValue();

        this.builtUpAreaService.updateBuiltUpArea(builtUpArea).subscribe((response) => {
            if (response.isSuccess) {
                // Show a success message
                this._alertMessage.success("BuiltUpArea updated successfully");
                // Close the dialog
                this._matDialogRef.close(response);
            }
            else {
                this._alertMessage.error(response.errors.join("\n"));
            }
        });

    }

    onClose(): void {
        this._matDialogRef.close();
    }

    displayOptionsFn(options: CommonDropDown[]): (name: string) => string {
        return (name: string) => {
            const correspondingOption = Array.isArray(options) ? options.find(option => option.name === name) : null;
            return correspondingOption ? correspondingOption.name : '';
        }
    }

    private _optionsfilter(name: string): CommonDropDown[] {
        const filterValue = name.toString().toLowerCase();

        return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
    }
}
